<template>
  <div>
    <div class="flex-invoice-box">
      <div class="flex-invoice-header">
        开票信息
        <img v-if="!$route.query.nav" class="image-close" src="../../assets/buycar/model-close.png" @click="cancle">
      </div>
      <div class="flex-invoice-body" :style="{ height }">
        <div class="flex-invoice-switch">
          <div class="flex-invoice-label">发票类型</div>
          <div class="flex-invoice-radio">
            <a-radio-group
              v-model="selected_canuse_receipt"
              :options="hasSwitchOptions"
              @change="onChangeSwitch"
            />
          </div>
          <div v-show="selected_canuse_receipt === '2'" class="flex-invoice-msg">
            <label>提醒：</label>
            增值税专用发票开具需2-3个工作日，为避免您的等待，推荐您开具电子普通发票！
          </div>
        </div>
        <div class="flex-invoice-form">
          <div class="flex-invoice-label">发票信息</div>
          <!-- 电子普通发票 -->
          <div v-if="selected_canuse_receipt != '2'" class="table">
            <div class="row">
              <em />
              <a-input
                v-model="form2.CorporateName"
                class="icon"
                :disabled="IsMian"
                placeholder="请填写发票抬头"
                :max-length="40"
                @change="form2.CorporateName = $hys.replaceBlankAndSpecial(form2.CorporateName)"
                @blur="checkName(form2.CorporateName)"
              />
            </div>
            <!-- 非营利性诊所电子普通发票隐藏税号信息 -->
            <div
              v-if="detailInfo.CustomerType === 1 || (detailInfo.CustomerType === 2 && detailInfo.BusinessNature === 1)"
              class="row"
            >
              <a-input
                v-model="form2.IdentificationNumber"
                :disabled="IsMian"
                :max-length="40"
                placeholder="请填写纳税人识别号"
                @change="form2.IdentificationNumber = $hys.replaceBlankAndSpecial(form2.IdentificationNumber)"
              />
            </div>
            <div class="row">
              <p>提醒:</p>
              <p>平台默认开具电子普通发票，电子普通发票是税局认可的有效收付款凭证，其法律效力、基本用途及使用规定同纸质发票，如需纸质普通发票可自行下载打印。</p>
            </div>
          </div>
          <!-- 增值税专用发票 -->
          <div v-if="selected_canuse_receipt === '2'" class="table">
            <div class="row flex">
              <div class="row-l">
                <div class="row">
                  <em />
                  <a-input
                    v-model="form.CorporateName"
                    :disabled="IsMian"
                    class="icon"
                    :max-length="40"
                    placeholder="请填写发票抬头"
                    @change="form.CorporateName = $hys.replaceBlankAndSpecial(form.CorporateName)"
                    @blur="checkName(form.CorporateName)"
                  />
                </div>
                <div class="row">
                  <em />
                  <a-input
                    v-model="form.IdentificationNumber"
                    class="icon"
                    :max-length="40"
                    placeholder="请填写纳税人识别号"
                    :disabled="IsMian"
                    @change="form.IdentificationNumber = $hys.replaceBlankAndSpecial(form.IdentificationNumber)"
                  />
                </div>
                <div class="row">
                  <em />
                  <a-input
                    v-model="form.Address"
                    class="icon"
                    :disabled="IsMian"
                    placeholder="请填写门店地址"
                    :max-length="40"
                    @change="form.Address = $hys.replaceBlankAndSpecial(form.Address)"
                  />
                </div>
                <div class="row">
                  <em />
                  <a-input
                    v-model="form.Phone"
                    class="icon"
                    :disabled="IsMian"
                    type="number"
                    :max-length="11"
                    placeholder="请填写联系人电话"
                    @change="form.Phone = $hys.replaceBlankAndSpecial(form.Phone)"
                  />
                </div>
                <div class="row">
                  <em />
                  <a-input
                    v-model="form.BankDeposit"
                    class="icon"
                    :disabled="IsMian"
                    :max-length="50"
                    placeholder="请填写开户银行"
                    @change="form.BankDeposit = $hys.replaceBlankAndSpecial(form.BankDeposit)"
                  />
                </div>
                <div class="row">
                  <em />
                  <a-input
                    v-model="form.BankAccount"
                    :max-length="30"
                    :disabled="IsMian"
                    class="icon"
                    placeholder="请填写银行账号"
                    @change="form.BankAccount = $hys.replaceBlank(form.BankAccount)"
                  />
                </div>
              </div>
              <div class="row-r">
                <!-- 图片上传 -->
                <!-- <div>
                  <img
                    width="10px"
                    height="10px"
                    style="margin: -2px 5px 0 0;"
                    src="../../assets/buycar/swtch-icon.png"
                  >
                  上传开票资料
                </div> -->
                <van-grid>
                  <div class="iFile-tips" style="width: 100%;">
                    <img
                      width="10px"
                      height="10px"
                      style="margin: -2px 5px 0 0;"
                      src="../../assets/buycar/swtch-icon.png"
                    >上传一般人纳税人申请表</div>
                  <van-grid-item
                    v-for="(item, index) in conUploader"
                    :key="index"
                    class="grid-item"
                  >
                    <iFile
                      style="width: 100px; height: 100px;"
                      :bg="_getPic(item.ImageUrl, true)"
                      readonly
                    >
                      <van-icon
                        name="clear"
                        size="20px"
                        style="position: absolute; top: -18px; left: 0;"
                        @click.stop="delImage(index)"
                      />
                    </iFile>
                  </van-grid-item>
                  <iFile
                    v-if="conUploader.length == 0"
                    class="grid-item"
                    :readonly="IsMian"
                    @change="onFile"
                  >
                    <img
                      width="36px"
                      height="36px"
                      style="margin-top: 30px;"
                      src="../../assets/mine/xiangji.png"
                    >
                  </iFile>
                </van-grid>
                <van-grid>
                  <span class="iFile-tips">
                    <!-- <img
                      width="10px"
                      height="10px"
                      style="margin: -2px 5px 0 0;"
                      src="../../assets/buycar/swtch-icon.png"
                    > -->
                    上传汇总纳税申请表（分店开连锁总部需上传）</span>
                  <van-grid-item
                    v-for="(item, index) in conUploader2"
                    :key="index"
                    class="grid-item"
                  >
                    <iFile
                      style="width: 100px; height: 100px;"
                      :bg="_getPic(item.ImageUrl, true)"
                      readonly
                    >
                      <van-icon
                        name="clear"
                        size="20px"
                        style="position: absolute; top: -18px; left: 0;"
                        @click.stop="delImage2(index)"
                      />
                    </iFile>
                  </van-grid-item>
                  <iFile
                    v-if="conUploader2.length == 0"
                    class="grid-item"
                    :readonly="IsMian"
                    @change="onFile2"
                  >
                    <img
                      width="36px"
                      height="36px"
                      style="margin-top: 30px;"
                      src="../../assets/mine/xiangji.png"
                    >
                  </iFile>
                </van-grid>
              </div>
            </div>
            <div class="row">
              <p>提醒:</p>
              <p>平台默认开具电子普通发票，电子普通发票是税局认可的有效收付款凭证，其法律效力、基本用途及使用规定同纸质发票，如需纸质普通发票可自行下载打印。</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selected_canuse_receipt != '2'" class="flex-invoice-footer">
        <van-button
          color="#0F6EEA"
          :disabled="!form2.CorporateName"
          @click.stop="
            () => {
              toPrice();
            }
          "
        >
          确定
        </van-button>
      </div>
      <div v-if="selected_canuse_receipt === '2'" class="flex-invoice-footer">
        <van-button
          color="#0F6EEA"
          :disabled="
            !(
              hasSubType &&
              form.CorporateName &&
              form.IdentificationNumber &&
              form.Address &&
              form.Phone &&
              form.BankDeposit &&
              form.BankAccount &&
              conUploader.length > 0
            )
          "
          @click.stop="
            () => {
              toPrice();
              selected_canuse_receipt = '2';
            }
          "
        >
          确定
        </van-button>
      </div>
    </div>
    <!--
      * 温馨提示 model
      * haolin.hu
      * 2022.2.15
      -->
    <a-modal
      v-model="show_remind"
      centered
      :footer="null"
      :closable="false"
      :mask-closable="false"
      width="573px"
      :body-style="{ padding: 0 }"
      :z-index="9999"
    >
      <div class="flex-remind-box">
        <div class="flex-remind-header">
          温馨提示
          <img
            class="image-close"
            src="../../assets/buycar/model-close.png"
            @click="() => {
              show_remind = false
              selected_canuse_receipt!='2' ? form2.CorporateName = oldCorporateName : form.CorporateName = oldCorporateName
            }"
          >
        </div>
        <div v-if="difference===1 || !!IsHead" class="flex-remind-body">
          <div class="subtitle">检测到您发票抬头与门店名称不一致，您是否需要修改门店名称？</div>
          <div class="block">
            <div>1. 门店名称修改后，后续所有发票和出库单都以新抬头开具。</div>
            <div>2. 门店名称修改之前的订单【出库单】和【发票】修改请联系客服。【联系客服：4001818000】</div>
          </div>
        </div>
        <div v-else>
          <div v-if="difference===2" class="flex-remind-body">
            <div class="subtitle">检测到您发票抬头与门店名称差异较大：</div>
            <div class="block">
              <div>1. 您是否需要绑定连锁机构？
                <router-link :to="{name:LinkTypeCode.InterlockSettings}" tag="a" target="_blank">
                  <span class="link">绑定连锁机构</span>
                </router-link>
              </div>
              <div>2. 门店名称修改之前的订单【出库单】和【发票】修改请联系客服。【联系客服：4001818000】</div>
            </div>
          </div>
        </div>
        <div class="flex-remind-footer">
          <van-button
            @click="
              () => {
                show_remind = false,
                selected_canuse_receipt!=2 ? form2.CorporateName = oldCorporateName : form.CorporateName = oldCorporateName
              }
            "
          >
            取消修改
          </van-button>
          <van-button
            color="#0F6EEA"
            :disabled="!form2.CorporateName"
            @click.stop="
              () => {
                show_remind = false
              }
            "
          >
            确认修改
          </van-button>
        </div>
      </div>
    </a-modal>
    <!-- 温馨提示 model end -->
  </div>
</template>
<script>
import { BaseMixin } from '../../mixins/BaseMixin.js'
import iFile from '@/components/uploader.vue'
import { LinkTypeCode } from '../../dictionary/base.js'

export default {
  name: 'ApplyInvoiceForm',
  components: { iFile },
  mixins: [BaseMixin],
  props: {
    isdialog: { type: Boolean, default: false },
    isReadOnly: { type: Boolean, default: false },
    height: { type: String, default: '409px' },
    // 商品合计
    sumData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      LinkTypeCode,
      // 发票判断对象
      detailInfo: {},
      PriceModel: 1,
      isdisplay: true,
      click: false,
      activeKey: [],
      // 发票类型
      hasSwitchOptions: [{ label: '电子普通发票', value: '1' }, { label: '增值税专用发票', value: '2' }],
      selected_canuse_receipt: '',
      form: {
        IdentificationNumber: '',
        BankDeposit: '',
        BankAccount: '',
        CorporateName: '',
        Address: '',
        Phone: ''
      },
      form2: {
        CorporateName: '',
        IdentificationNumber: ''
      },
      priceType: '',
      OrderInvoiceType: '',
      conUploader: [],
      conUploader2: [],
      Id: '',
      nav: false,
      // 计算对象
      sumDataInfo: null,
      // 提交按钮点击限制
      hasSubType: true,

      // 是否选择的主店
      IsMian: false,
      // 温馨提示弹窗
      show_remind: false,
      difference: 1,
      oldCorporateName: '',
      IsHead: false
    }
  },
  watch: {
    // 监听参数变化（商品合计）
    sumData: {
      handler(newData, oldData) {
        if (newData) {
          this.sumDataInfo = Number(newData.TotalAmountPayable - newData.PayLogisticsAmount)
        }
      },
      deep: true,
      immediate: false
    }
  },
  async mounted() {
    if (this.$route.query.nav) {
      this.nav = true
    } else {
      this.nav = false
    }
    this.loadData()
    this.GetInvoiceInformationList()
  },
  methods: {
    async judgHeadStore() {
      const res = await this.getAction(
        '/api_customers/MutiCustomer/JudgHeadStore'
      )
      if (res.IsSuccess && res.Data && res.Data.Type == 1) {
        this.IsHead = true
      }
    },
    /**
			 * 发票类型切换
			 * xuzhongqi
			 * 2020.12.07
			 * @param {e} radio 当前选中对象
			 */
    onChangeSwitch(e) {
      if (this.sumDataInfo === null) {
        this.selected_canuse_receipt = e.target.value
      } else {
        // 判断发票类型
        // 专项发票
        if (e.target.value === '2') {
          // 判断金额
          if (this.sumDataInfo < 500) {
            this.$toast({ position: 'bottom', message: '商品实付金额小于500，请申请电子普通发票！' })
            this.hasSubType = false
          } else {
            this.selected_canuse_receipt = e.target.value
          }
        } else {
          this.selected_canuse_receipt = e.target.value
        }
      }
    },
    goApplyInvoice(id) {
      const json = {
        Id: id
      }
      this.setApplyInvoiceId(json)
    },
    async getCustomerInfoData() {
      // 获取用户信息
      const res = await this.getAction('/api_customers/Customer/GetCustomerInfo')
      if (res.IsSuccess) {
        // 保存接口反回参数
        this.detailInfo = res.Data
      }
    },
    /**
			 * 通过接口获取发票列表(连锁新增)
			 * lt
			 * 2020.09.10
			 * **/
    async GetInvoiceInformationList() {
      const res = await this.getAction('/api_customer/InvoiceInformation/List', {

      })
      if (res.IsSuccess) {
        this.InvoiceInformationList = res.Data
      }
    },
    async setApplyInvoiceId(item) {
      console.log(item)
      // this.Id = item.Id
      this.OrderId = item.Id
      if (item.OrderInvoiceCustomerId && item.OrderInvoiceCustomerId != this.detailInfo.Id) {
        this.IsMian = true
      } else {
        this.IsMian = false
      }
      // setTimeout(() => {
      // if (this.InvoiceInformationList.length == 2 && item.OrderInvoiceCustomerId) {

      // }
      this.initInvoce(item.OrderInvoiceCustomerId)
      // }, 1000)
      if (item.TotalAmountPayable) {
        this.sumDataInfo = Number(item.TotalAmountPayable)
      }
      // 获取用户信息
      this.getCustomerInfoData()
      // 获取订单编号
      const res = await this.getAction('/api_aftersale/OrderInvoice/GetOrderInvoice', { orderId: item.Id })
      if (res.IsSuccess && res.Data.length > 0) {
        this.selected_canuse_receipt = res.Data[0].OrderInvoiceType === 1 ? 1 : 2
      }
    },
    // 连锁信息新增开票逻辑
    initInvoce(Id) {
      // 发票信息回显
      console.log(this.InvoiceInformationList, 'SHSHHS')
      const data = this.InvoiceInformationList.filter((item) => item.CustomerId == Id)[0]
      this.form['Id'] = data.Id
      this.form['IdentificationNumber'] = data.IdentificationNo || this.getCustomerInfo()
      this.form['BankDeposit'] = data.BankOfDeposit || ''
      this.form['BankAccount'] = data.BankAccount || ''
      this.form['CorporateName'] = data.Name || this.auth.getCustomerName()
      this.form['Address'] = data.Address || (this.auth.getCustomerInfo() ? this.auth.getCustomerInfo()[
        'Address'] : '')
      this.form['Phone'] = data.Phone || (this.auth.getCustomerInfo() ? this.auth.getCustomerInfo()['Phone']
        : '')
      this.form2['CorporateName'] = data.Name || this.auth.getCustomerName()
      this.form2['IdentificationNumber'] = data.IdentificationNo || this.getCustomerInfo()
      if (data.IdentificationPicUrl) {
        this.conUploader.push({ ImageUrl: data.IdentificationPicUrl })
      }
      if (data.IdentificationSummaryUrl) {
        this.conUploader2.push({ ImageUrl: data.IdentificationSummaryUrl })
      }
    },
    delImage(index) {
      this.conUploader.splice(index, 1)
    },
    delImage2(index) {
      this.conUploader2.splice(index, 1)
    },
    cancle() {
      this.$emit('cancel')
    },
    onFile(file) {
      this.SignImage = file
      const img = {
        ImageUrl: this.SignImage
      }
      this.conUploader.push(img)
    },
    onFile2(file) {
      this.SignImage = file
      const img = {
        ImageUrl: this.SignImage
      }
      this.conUploader2.push(img)
    },
    async toPrice() {
      let params = ''
      let res = ''
      console.log(this.selected_canuse_receipt)
      if (!this.selected_canuse_receipt) {
        this.$toast({ position: 'bottom', message: '请选择发票类型' })
        return false
      }
      if (this.nav) {
        if (this.selected_canuse_receipt != 2) {
          // 判断是否为诊所
          if (this.detailInfo.CustomerType === 2) {
            // 判断是否营利性
            if (this.detailInfo.BusinessNature === 1) {
              // 营利性
              if (this.form2['IdentificationNumber']) {
                if (!(this.form2['IdentificationNumber'].length > 14 && this.form2[
                  'IdentificationNumber'].length < 26)) {
                  this.$toast({ position: 'bottom', message: '请填写正确纳税人识别号' })
                  return false
                }
              }
            }
          } else {
            // 药店，正常校验识别号
            if (this.form2['IdentificationNumber']) {
              if (!(this.form2['IdentificationNumber'].length > 14 && this.form2[
                'IdentificationNumber'].length < 26)) {
                this.$toast({ position: 'bottom', message: '请填写正确纳税人识别号' })
                return false
              }
            }
          }

          params = {
            Id: this.Id,
            Name: this.form2['CorporateName'],
            IdentificationNo: this.form2['IdentificationNumber'],
            BankOfDeposit: '',
            BankAccount: '',
            Address: '',
            Phone: this.detailInfo.Phone,
            IdentificationPicUrl: '',
            Type: 1
          }
        } else {
          if (this.form['IdentificationNumber']) {
            if (!(this.form['IdentificationNumber'].length > 14 && this.form['IdentificationNumber']
              .length < 26)) {
              this.$toast({ position: 'bottom', message: '请填写正确纳税人识别号' })
              return false
            }
          }
          params = {
            Id: this.Id,
            Name: this.form['CorporateName'],
            IdentificationNo: this.form['IdentificationNumber'],
            BankOfDeposit: this.form['BankDeposit'],
            BankAccount: this.form['BankAccount'],
            Address: this.form['Address'],
            Phone: this.form['Phone'],
            IdentificationPicUrl: this.conUploader[0].ImageUrl,
            IdentificationSummaryUrl: this.conUploader2.length ? this.conUploader2[0]['ImageUrl'] : null,
            Type: 2
          }
        }
        this.$hys.openLoading()

        res = await this.putAction('api_customer/InvoiceInformation/AddOrUpdate', params)
      } else {
        if (this.selected_canuse_receipt != 2) {
          // 判断是否为诊所
          if (this.detailInfo.CustomerType === 2) {
            // 判断是否营利性
            if (this.detailInfo.BusinessNature === 1) {
              // 营利性
              if (this.form2['IdentificationNumber']) {
                if (!(this.form2['IdentificationNumber'].length > 14 && this.form2[
                  'IdentificationNumber'].length < 26)) {
                  this.$toast({ position: 'bottom', message: '请填写正确纳税人识别号' })
                  return false
                }
              }
            }
          } else {
            // 药店，正常校验识别号
            if (this.form2['IdentificationNumber']) {
              if (!(this.form2['IdentificationNumber'].length > 14 && this.form2[
                'IdentificationNumber'].length < 26)) {
                this.$toast({ position: 'bottom', message: '请填写正确纳税人识别号' })
                return false
              }
            }
          }
          console.log(this.detailInfo)
          console.log(this.Id)
          params = {
            OrderId: this.OrderId,
            OrderInvoiceType: this.selected_canuse_receipt == 1 || this.selected_canuse_receipt ==
								3 ? 1 : 2,
            OrderInvoiceMediumType: this.selected_canuse_receipt == 1 ? 1 : 2,
            InvoiceInformationDto: {
              Name: this.form2['CorporateName'],
              IdentificationNo: this.form2['IdentificationNumber']
            }
          }
        } else {
          if (this.form['IdentificationNumber']) {
            if (!(this.form['IdentificationNumber'].length > 14 && this.form['IdentificationNumber']
              .length < 26)) {
              this.$toast({ position: 'bottom', message: '请填写正确纳税人识别号' })
              return false
            }
          }
          params = {
            OrderId: this.OrderId,
            OrderInvoiceType: this.selected_canuse_receipt == 1 || this.selected_canuse_receipt ==
								3 ? 1 : 2,
            OrderInvoiceMediumType: this.selected_canuse_receipt == 1 ? 1 : 2,
            InvoiceInformationDto: {
              Name: this.form['CorporateName'],
              IdentificationNo: this.form['IdentificationNumber'],
              BankOfDeposit: this.form['BankDeposit'],
              BankAccount: this.form['BankAccount'],
              Address: this.form['Address'],
              Phone: this.form['Phone'],
              IdentificationPicUrl: this.conUploader[0].ImageUrl,
              IdentificationSummaryUrl: this.conUploader2.length ? this.conUploader2[0]['ImageUrl'] : null
            }
          }
        }
        this.$hys.openLoading()
        if (this.$route.query.reInvoice) {
          console.log(params)
          const _params = {
            OrderId: this.OrderId,
            Id: this.form.Id,
            Name: params.InvoiceInformationDto.Name,
            OrderInvoiceTitleType: params.OrderInvoiceType,
            OrderInvoiceMediumType: params.OrderInvoiceMediumType,
            IdentificationNo: params.InvoiceInformationDto.IdentificationNo,
            BankOfDeposit: params.InvoiceInformationDto.BankOfDeposit,
            BankAccount: params.InvoiceInformationDto.BankAccount,
            Address: params.InvoiceInformationDto.Address,
            Phone: params.InvoiceInformationDto.Phone,
            IdentificationPicUrl: params.InvoiceInformationDto.IdentificationPicUrl,
            IdentificationSummaryUrl: params.InvoiceInformationDto.IdentificationSummaryUrl
          }

          res = await this.postAction('/api_aftersale/OrderInvoice/SecondaryInvoicing', _params)
        } else {
          res = await this.postAction('/api_aftersale/OrderInvoice/AfterInvoicing', params)
        }
      }

      this.$hys.clearLoading()
      if (res.IsSuccess) {
        this.priceType =
            this.selected_canuse_receipt == 1
              ? '电子普通发票'
              : this.selected_canuse_receipt == 2
                ? '增值税专用发票'
                : this.selected_canuse_receipt == 3
                  ? '纸质普通发票'
                  : '暂不开票'
        this.$toast.success('提交成功')
        this.cancle()
        location.reload()
        setTimeout(() => {
          this.conUploader = []
          this.conUploader2 = []
          this.btn = false
        }, 1500)
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
        this.btn = false
      }
    },
    // 获取客户信息
    async getCustomerInfo() {
      const res = await this.getAction('/api_customers/Customer/GetBusinessLincenseAttr')
      if (res.IsSuccess && res.Data.length > 0) {
        if (res.Data.length > 0) {
          this.form['IdentificationNumber'] = res.Data[0].CustomerAttrDtos[0].AttrValue || ''
          this.form2['IdentificationNumber'] = res.Data[0].CustomerAttrDtos[0].AttrValue || ''
        } else {
          this.form['IdentificationNumber'] = ''
          this.form2['IdentificationNumber'] = ''
        }
      } else {
        this.form['IdentificationNumber'] = ''
        this.form2['IdentificationNumber'] = ''
      }
    },

    async loadData() {
      this.$hys.openLoading()
      // 获取发票信息
      const res = await this.getAction('/api_customer/InvoiceInformation/Detail')

      if (res.IsSuccess && res.Data) {
        if (this.nav) {
          this.Id = res.Data.Id
        }
        // 发票信息回显
        this.form['IdentificationNumber'] = res.Data.IdentificationNo || this.getCustomerInfo()
        this.form['BankDeposit'] = res.Data.BankOfDeposit || ''
        this.form['BankAccount'] = res.Data.BankAccount || ''
        this.form['CorporateName'] = res.Data.Name || this.auth.getCustomerName()
        this.oldCorporateName = this.form['CorporateName']
        this.form['Address'] = res.Data.Address || (this.auth.getCustomerInfo() ? this.auth
          .getCustomerInfo()['Address'] : '')
        this.form['Phone'] = res.Data.Phone || (this.auth.getCustomerInfo() ? this.auth.getCustomerInfo()[
          'Phone'] : '')
        this.form2['CorporateName'] = res.Data.Name || this.auth.getCustomerName()
        this.form2['IdentificationNumber'] = res.Data.IdentificationNo || this.getCustomerInfo()
        if (res.Data.IdentificationPicUrl) {
          this.conUploader.push({ ImageUrl: res.Data.IdentificationPicUrl })
        }
        if (res.Data.IdentificationSummaryUrl) {
          this.conUploader2.push({ ImageUrl: res.Data.IdentificationSummaryUrl })
        }
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }

      const resTo = await this.getAction('/api_aftersale/OrderInvoice/GetOrderInvoiceListByCustomerId')
      if (resTo.IsSuccess) {
        if (resTo.Data == null) {
          this.priceType = '请选择'
        } else {
          this.priceType = resTo.Data.OrderInvoiceTypee_txt
          this.selected_canuse_receipt = resTo.Data.OrderInvoiceType
        }
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
      this.$hys.clearLoading()
      // 获取用户信息
      this.getCustomerInfoData()
    },

    checkName(_val) {
      const _old = this.oldCorporateName

      const l = _old.length > _val.length ? _old.length : _val.length
      const d = this.strSimilarity2Number(_old, _val)
      const difference = (d / l).toFixed(2) * 100
      if (difference > 0) {
        this.show_remind = true
        this.difference = difference <= 30 ? 1 : 2
      }
    },
    strSimilarity2Number(s, t) {
      const n = s.length
      const m = t.length
      const d = []
      let i, j, s_i, t_j, cost
      if (n == 0) return m
      if (m == 0) return n
      for (i = 0; i <= n; i++) {
        d[i] = []
        d[i][0] = i
      }
      for (j = 0; j <= m; j++) {
        d[0][j] = j
      }
      for (i = 1; i <= n; i++) {
        s_i = s.charAt(i - 1)
        for (j = 1; j <= m; j++) {
          t_j = t.charAt(j - 1)
          if (s_i == t_j) {
            cost = 0
          } else {
            cost = 1
          }
          d[i][j] = this.Minimum(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost)
        }
      }
      return d[n][m]
    },
    Minimum(a, b, c) {
      return a < b ? (a < c ? a : c) : (b < c ? b : c)
    }
  }
}
</script>
<style lang="less" scoped>
  @import url('~@/styles/confirmOrder.less');

  .flex-invoice-box {
    border: 1px solid #E8E8E8;
    height: initial;
    text-align: left;
    background-color: #FFFFFF;

    .flex-invoice-body {
      .flex-invoice-form .table .row .row-r .iFile-tips {
        width: 100%;
      }
    }

    .flex-invoice-footer {
      position: relative;
    }

    .flex-invoice-msg {
      padding-top: 10px;

      label {
        color: red;
      }
    }
  }
</style>
